import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { getPreviousSeasonYear } from '@/lib/season';
import { useSeason } from '@/context/SeasonContext';

export const useTDDIneligibleTeams = (
  seasonOverride?: string,
  leagueId?: string,
  competitionId?: number | null
) => {
  const { leagueActiveSeason } = useSeason();
  const season = seasonOverride ?? getPreviousSeasonYear(leagueActiveSeason);
  return useQuery({
    queryKey: ['tdd-ineligible-teams', season, leagueId, competitionId],
    queryFn: async () => {
      // If leagueId provided, try league-specific override first
      if (leagueId) {
        const { data: leagueData, error: leagueError } = await supabase
          .from('tdd_ineligible_teams')
          .select('team_name')
          .eq('season', season)
          .eq('league_id', leagueId);

        if (leagueError) {
          console.error('Error fetching league TDD ineligible teams, falling back to global:', leagueError);
        } else if (leagueData && leagueData.length > 0) {
          return leagueData.map((row) => row.team_name as string);
        }
      }

      // Fall back to global defaults, scoped by competition_id
      let query = supabase
        .from('tdd_ineligible_teams')
        .select('team_name')
        .eq('season', season)
        .is('league_id', null);

      if (competitionId != null) {
        query = query.eq('competition_id', competitionId);
      }

      const { data, error } = await query;

      if (error) {
        console.error('Error fetching TDD ineligible teams:', error);
        throw error;
      }

      return (data || []).map((row) => row.team_name as string);
    },
    staleTime: 24 * 60 * 60 * 1000,
  });
};
